import {useAuth} from 'attendee/Auth/Providers/AuthProvider'
import React, {ReactElement} from 'react'
import {Helmet} from 'react-helmet'
import {routes} from 'routes/routes'
import {NavigateLocalized} from 'i18n/NavigateLocalized'

export function AuthReqired(props: {children: ReactElement}) {
  const {user} = useAuth()

  if (!user) return <NavigateLocalized to={routes.login} replace />

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      {props.children}
    </>
  )
}
